<script lang="typescript">
    // packages
    import { json } from 'd3-fetch';
    import { onMount } from 'svelte';
  
    // components
    import NationalMap from './maps/CanvasMap.svelte';
    import MapKey from './MapKey.svelte';
  
    // utils
    import { getGeoJsonFromTopoJson } from '../utils/topojson-to-geojson';
  
    // constants
    import { US_GEOGRAPHYURL } from '../constants';
  
    // types
    import type { Readable } from 'svelte/store';
    import type { PresidentRaceFeed, OfficeRaceInterface } from '../interfaces';
  
    // props
    export let feed: Readable<PresidentRaceFeed>;

    // state
    const options = ['states', 'counties'];
  
    let topology;
    let active = options[0];
  
    $: states = topology && getGeoJsonFromTopoJson(topology, 'states', true);
  
    $: geography =
      topology &&
      (active === 'states'
        ? states
        : getGeoJsonFromTopoJson(topology, active, true));
  
    $: resultsByFips = new Map(
      $feed[active].map((state: OfficeRaceInterface) => [state.code, state])
    );

    $: electoralVoteDistrictRaces = $feed["districts"];
  
    onMount(async () => {
      const response = await json(US_GEOGRAPHYURL);
  
      if (response) {
        topology = response;
      }
    });
    
  </script>

  <div class="mt-1 mb-2" role="presentation" aria-label="Map of the United States presidential race, by state.">
    {#each options as option}
      <label class="text-sans-serif" class:active={option === active}>
        <input type="radio" bind:group={active} value={option} />
        {option}</label>
    {/each}
  </div>
  
  <MapKey noLeads={active === 'counties'} />
  
  <div class="position-relative" >
    {#if geography}
      <NationalMap
        {geography}
        globalInnerlines={active === 'counties' ? states.innerlines : undefined }
        data={resultsByFips}
        divisionType={active === 'states' ? 'state' : 'county'}
        electoralVoteDistrictRaces={active === 'states' ? electoralVoteDistrictRaces : null}
      />
    {/if}
  </div>
  
